/**
 * WordPress dependencies
 */
import { CheckboxControl } from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { useAttributes } from '../hooks';

import { DEFAULT_ATTRS } from './config';
import type { FieldSettingProps } from '../types';

export const PublicCheckerSetting = ( {
	name: settingName,
	disabled,
}: FieldSettingProps ): JSX.Element => {
	const [ attributes, setAttributes ] = useAttributes(
		settingName,
		DEFAULT_ATTRS
	);
	const { enabled, includeNames } = attributes;

	return (
		<div className="nab-gdpr-cookie-setting">
			<CheckboxControl
				checked={ enabled }
				onChange={ ( v ) =>
					setAttributes(
						v
							? { enabled: true }
							: { enabled: false, includeNames: false }
					)
				}
				disabled={ disabled }
				label={ _x(
					'Show debugging tools on the site (staging only)',
					'command',
					'nelio-ab-testing'
				) }
			/>
			{ enabled && (
				<CheckboxControl
					checked={ includeNames }
					onChange={ ( v ) => setAttributes( { includeNames: v } ) }
					disabled={ disabled }
					label={ _x(
						'Include test names in public script',
						'command',
						'nelio-ab-testing'
					) }
				/>
			) }
			<input
				type="hidden"
				name={ settingName }
				value={ JSON.stringify( attributes ) }
			/>
		</div>
	);
};
